import React, { memo } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import chevronRightIcon from "@layouts/betto/assets/chevronRight.svg";
import { LoveIcon } from "@pages/casino/assets/icons";
import {
	BettoExplorePlaceholderCard,
	BettoExplorePlaceholderGrid,
} from "@pages/casino/containers/BettoSearchModal/elements";

const glassBorder = css`
	isolation: isolate;

	&::after {
		content: "";
		position: absolute;
		inset: 0;
		border-radius: inherit;
		border: 1px solid #ffffff;
		mix-blend-mode: overlay;
		pointer-events: none;
	}
`;

const WRAPPER = styled.div`
	position: relative;
	width: 100%;
	margin-top: 8px;
`;

const OVERLAY = styled.div`
	position: absolute;
	inset: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 24px 16px;
	text-align: center;
`;

const BADGE = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
	padding: 20px 24px;
	border-radius: 12px;
	background: rgba(23, 28, 42, 0.92);
	border: 1px solid rgba(255, 255, 255, 0.08);
	max-width: 320px;
`;

const TITLE = styled.h2`
	margin: 0;
	font-size: 16px;
	font-weight: 600;
	color: #e5f0fe;
`;

const HINT = styled.p`
	margin: 0;
	font-size: 13px;
	line-height: 1.45;
	color: #858faf;
`;

const ACTION = styled.button`
	position: relative;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	margin-top: 8px;
	height: 38px;
	padding: 0 14px;
	border: none;
	border-radius: 10px;
	background: #0362d4;
	color: #e5f0fe;
	font-family: var(--bt-font-family, inherit);
	font-size: 14px;
	font-weight: 500;
	line-height: 1;
	cursor: pointer;
	transition:
		background 0.2s ease,
		transform 0.2s ease;
	${glassBorder}

	&:hover {
		background: #0470ef;
	}

	&:active {
		transform: scale(0.98);
	}
`;

const ACTION_ICON = styled.img`
	width: 14px;
	height: 14px;
	display: block;
	flex-shrink: 0;
`;

export const BettoFavoritesEmpty = memo(({ translate, onExploreAllGames }) => (
	<WRAPPER>
		<BettoExplorePlaceholderGrid aria-hidden>
			{Array.from({ length: 6 }, (_, index) => (
				<BettoExplorePlaceholderCard
					key={`favorites-empty-${index}`}
					$dimmed={index % 2 === 0}
				/>
			))}
		</BettoExplorePlaceholderGrid>
		<OVERLAY>
			<BADGE>
				<LoveIcon
					width={28}
					height={28}
				/>
				<TITLE>{translate("casino.noFavGames")}</TITLE>
				<HINT>{translate("casino.youCanAddFav")}</HINT>
				<ACTION
					type="button"
					onClick={onExploreAllGames}>
					<span>{translate("betto.casino.exploreMoreGames")}</span>
					<ACTION_ICON
						src={chevronRightIcon}
						alt=""
					/>
				</ACTION>
			</BADGE>
		</OVERLAY>
	</WRAPPER>
));

BettoFavoritesEmpty.displayName = "BettoFavoritesEmpty";

BettoFavoritesEmpty.propTypes = {
	translate: PropTypes.func.isRequired,
	onExploreAllGames: PropTypes.func.isRequired,
};

export default BettoFavoritesEmpty;
